import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './value-proposition.component.scss';
var ValueProposition = /** @class */ (function (_super) {
    tslib_1.__extends(ValueProposition, _super);
    function ValueProposition(element) {
        return _super.call(this, element) || this;
    }
    ValueProposition.prototype.init = function () { };
    ValueProposition.prototype.bindEvents = function () { };
    return ValueProposition;
}(Base));
export { ValueProposition };



//////////////////
// WEBPACK FOOTER
// ./components/value-proposition/value-proposition.component.ts
// module id = 550
// module chunks = 0